import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LoginLayoutComponent } from './login-layout.component';
import { LoginComponent } from './login/login.component';
import { GspSharedModule } from '../../modules';
import { LoginLayoutRoutes } from './login-layout-routes';
import { LogOutComponent } from './logOut/logOut.component';
import { OktaWidgetComponent } from './okta-widget/okta-widget.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GspSharedModule,
    RouterModule.forChild(LoginLayoutRoutes)
  ],
  declarations: [
    LoginLayoutComponent,
    LoginComponent,
    LogOutComponent,
    OktaWidgetComponent
  ],
  
})
export class LoginLayoutModule { }
